<main
  class="relative flex min-h-screen items-center justify-center bg-cover bg-center p-4"
  style="background-image: url('assets/img/background.webp');"
>
  <div class="absolute inset-0 bg-[#993225]/70"></div>
  <div class="relative w-full max-w-md rounded-2xl bg-white p-8 shadow-xl">
    <header class="mb-8 text-center">
      <img
        src="assets/img/Logo_sidemenu.png"
        alt="Latour &amp; Petit"
        class="mx-auto h-28 w-auto"
      />
      <h1 class="mt-6 text-lg font-medium text-gray-700">Gestion locative</h1>
    </header>

    <button
      type="button"
      [disabled]="connecting()"
      (click)="signInWithMicrosoft()"
      class="flex w-full items-center justify-center gap-3 rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-800 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#993225] disabled:opacity-50"
    >
      <svg viewBox="0 0 21 21" class="h-5 w-5" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      {{ connecting() ? 'Connexion…' : 'Continuer avec Microsoft' }}
    </button>

    <p class="mt-8 text-center text-xs text-gray-500">
      Contactez votre administrateur en cas de problème de connexion.
    </p>
  </div>
</main>
